/**
 * Debug helpers for calcs only — safe for browser (Vite), Node (verify-calcs), and Jint bundles.
 * Do not import @/utils/debug from calcs; that couples calcs to Vite's import.meta handling.
 */
function isDev(): boolean {
    if (typeof process !== 'undefined' && process.env) {
        return process.env.NODE_ENV !== 'production';
    }
    try {
        return import.meta.env.DEV === true;
    } catch {
        return false;
    }
}

export function debugLog(...args: unknown[]): void {
    if (isDev()) {
        console.debug(...args);
    }
}

export function debugError(...args: unknown[]): void {
    console.error(...args);
}
